module.exports = __webpack_public_path__ + "img/ectivemsp70.a9a9fb66.png";